import React from 'react'
import { observer } from 'mobx-react'

import NoChartData from './NoChartData'

const InheritedChartSlot = ({ store, position }) => {
    const slide = store.activeSlide
    const question = slide.question.get(position)

    if (!question) return null

    const data = store.getChartDataForQuestion(
        `${question.surveyId}-${question.questionId}-inherited`,
        position,
    )

    return (
        <div className="pp-chart-slot-container">
            <div className="pp-slide-controls">
                <div className="pp-slide-edit" onClick={store.handleEditInherited}>
                    <i className="fas fa-pen-to-square" />
                </div>
            </div>
            <div className="pp-derived-slot">
                {question
                    ? store.getChart(
                        {
                            ...data,
                            title: '',
                            containerSize: { height: 400, width: 450 },
                            chartType: question.chart === 'inheritedStackedBar' ? 'inheritedStackedBar' : 'standardColumn',
                            surveyId: question.surveyId,
                            surveyDefaultLocale: question.surveyDefaultLocale || data?.surveyDefaultLocale,
                            settings: question.settings,
                            kpiType: 'inherited',
                            position,
                        },
                        data.data,
                    ) || <NoChartData question={question} />
                    : null}
            </div>
        </div>
    )
}

export default observer(InheritedChartSlot)
